import { FgdsProductType } from "@domain/product/product";
import { FloorplanPlaceholder } from "@domain/project/floorplan/floorplan-placeholder";
import { FloorplanService } from "@project/floorplanner/floorplan.service";

export function createFgdsPlaceholder(productType: FgdsProductType, floorplanService: FloorplanService): FloorplanPlaceholder {
  const floorplan = floorplanService.selectedFloorplan;
  switch (productType) {
    case FgdsProductType.GASWARNINGCENTER:
      floorplanService.addGasWarningCenterPlaceholder();
      return floorplan.gasWarningCenterPlaceholders.at(-1)!;
    case FgdsProductType.TRANSMITTER:
      floorplanService.addTransmitterPlaceholder();
      return floorplan.transmitterPlaceholders.at(-1)!;
    case FgdsProductType.SIGNALELEMENT:
      floorplanService.addSignalElementPlaceholder();
      return floorplan.signalElementPlaceholders.at(-1)!;
    case FgdsProductType.PLASTICSIGN:
      floorplanService.addPlasticSignPlaceholder();
      return floorplan.plasticSignPlaceholders.at(-1)!;
    case FgdsProductType.ALARMDEVICE:
      floorplanService.addAlarmDevicePlaceholder();
      return floorplan.alarmDevicePlaceholders.at(-1)!;
    default:
      throw new Error(`No placeholder handler for FgdsProductType: ${productType}`);
  }
}
